import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { Text } from '@/components/UberForm'
export const NavContainer = styled.nav`
	flex-grow: 0;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 0.25rem;
	background: ${(props) => props.theme.colors.layout.topBackgroundColor};
	color: white;
	padding: 0 0.75rem 0 0.5rem;
	height: 2.75rem;
`

export const NavBrand = styled.h1`
	margin: 0;
	margin-right: 0.5rem;
	font-size: 0.95rem;
	font-weight: 700;
	letter-spacing: 0.01em;
	white-space: nowrap;
`

export const NavBrandIcon = styled.img`
	display: block;
	height: 32px;
	width: 32px;
	flex-shrink: 0;
	object-fit: contain;
`

export const NavDivider = styled.span`
	display: inline-block;
	width: 1px;
	height: 1.25rem;
	margin: 0 0.25rem 0 0.75rem;
	background: rgba(255, 255, 255, 0.25);
`

export const UserCompany = styled.div`
	font-size: 1.5rem;
	font-weight: 200;
	margin-left: 0.5rem;
	&:before {
		content: '-';
		margin-right: 0.5rem;
	}
`
export const FilterSelectWrap = styled.div`
	display: inline-flex;
	align-items: center;
	margin-right: 0.625rem;
	margin-bottom: 0.4375rem;
	border-radius: 2px;
	transition: 0.25s all;
	min-width: 5rem;
	.MuiSelect-select {
		min-height: unset;
	}
	&:hover {
		background-color: rgba(144, 202, 249, 0.08);
	}
`

export const FilterLabel = styled.span`
	color: white;
	font-size: 0.9375rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 1px;
	margin-right: 0.5rem;
	white-space: nowrap;
`

export const StyledLink = styled(Link)<{
	current: boolean
}>`
	display: inline-block;
	padding: 0.875rem 0.875rem 0.4375rem 0.875rem;
	margin-bottom: 0.4375rem;
	margin-right: 0.625rem;
	text-transform: uppercase;
	letter-spacing: 1px;
	font-size: 0.9375rem;
	color: white;
	text-decoration: none;
	transition: 0.25s all;
	border-bottom: ${(props) =>
		props.current ? '1px solid #fff' : '1px solid transparent'};
	&:hover {
		background-color: rgba(144, 202, 249, 0.08);
	}
`
export const SearchWrap = styled.div`
	margin-left: auto;
	flex-grow: 1;
	margin-right: 0.625rem;
	max-width: 22rem;
	position: relative;

	[data-testid='text-input-container'] {
		background: rgba(255, 255, 255, 0.12);
		border: 1px solid rgba(255, 255, 255, 0.18);
		border-radius: 0.5rem;
		padding: 0.15rem 0.5rem;
		color: rgba(255, 255, 255, 0.9);
	}

	input {
		color: #fff !important;

		&::placeholder {
			color: rgba(255, 255, 255, 0.55);
		}
	}
`
export const StyledText = styled(Text)`
	${(props) => css`
		color: #fff;
		&&&:focus {
			border-color: ${props.theme.colors.input.border};
		}
	`}
`

export const UserMenuButton = styled.button<{ $isOpen: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	font-size: 0.875rem;
	user-select: none;
	cursor: pointer;
	color: white;
	border: 0;
	background: ${(props) =>
		props.$isOpen ? 'rgba(255, 255, 255, 0.12)' : 'transparent'};
	padding: 0.25rem 0.5rem;
	border-radius: 0.5rem;

	&:hover {
		background: rgba(255, 255, 255, 0.08);
	}
`

export const UserAvatar = styled.span`
	display: inline-flex;
	height: 1.75rem;
	width: 1.75rem;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	border-radius: 9999px;
	background: #db433a;
	color: #fff;
	font-size: 0.65rem;
	font-weight: 700;
	letter-spacing: 0.02em;
`

export const UserAvatarLarge = styled(UserAvatar)`
	height: 2.25rem;
	width: 2.25rem;
	font-size: 0.75rem;
`

export const UserName = styled.div`
	max-width: 11rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	line-height: 1.15;
`

export const UserNamePrimary = styled.span`
	font-size: 0.8125rem;
	font-weight: 600;
`

export const UserNameSecondary = styled.span`
	font-size: 0.6875rem;
	font-weight: 400;
	opacity: 0.75;
	max-width: 11rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const UserDropIcon = styled(FontAwesomeIcon)`
	font-size: 0.7rem;
	opacity: 0.85;
`

export const UserMenuPanel = styled.div`
	background: #fff;
	color: ${(props) => props.theme.colors.text.base};
`

export const UserMenuLogout = styled.button`
	display: flex;
	align-items: center;
	gap: 0.625rem;
	width: 100%;
	border: 0;
	background: transparent;
	cursor: pointer;
	padding: 0.75rem 1.1rem;
	font-size: 0.875rem;
	font-weight: 500;
	color: #2a2a2a;
	text-align: left;

	&:hover {
		background: rgba(31, 73, 84, 0.06);
		color: #1f4954;
	}
`

export const Container = styled.div`
	padding: 5px 0 5px 0;
	position: relative;
	color: ${(props) => props.theme.colors.text.base};
	background-color: white;
	box-shadow: ${(props) => props.theme.styles.rightMenusShadows};
`

export const MenuButton = styled.button`
	background: transparent;
	border-bottom: 1px solid #ddd;
	border-top: 1px solid #ddd;
	padding: 8px 12px;
	display: flex;
	cursor: pointer;
	width: 100%;
	&:hover {
		background: ${(props) => props.theme.colors.button.primary.background};
		color: white;
	}
`

export const Separator = styled.div`
	height: 5px;
`

export const UserIcon = styled(FontAwesomeIcon)`
	margin: 0 4px 0 8px;
`

export const MenuButtonIcon = styled(FontAwesomeIcon)`
	flex: 0;
`

export const UserBackgroundIcon = styled(FontAwesomeIcon)`
	position: absolute;
	opacity: 0.15;
	top: 13px;
	left: 15px;
	font-size: 64px;
`

export const MenuButtonText = styled.div`
	flex: 1;
`

export const MenuItem = styled.div`
	padding: 6px 10px;
	text-align: right;
`
